<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                [routerLink]="['/companydocument/companypolicymaster/add/',0]" [disabled]="isDisabled">
                <i class="bi bi-backpack" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Policy':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Company Policy Master
        </div>
        <div class="card-body p-1" style="width: 100%; overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsDelete}">Delete</th>
                        <th style="width: 40px;">Document</th>
                        <th style="width: 100px;">Policy Name </th>
                        <th>Company Policy Type</th>
                        <th style="width: 50px;">WebESSApplicability</th>
                        <th>Is Training Video</th>
                        <!-- <th>Description</th> -->
                        <th style="width: 10px;">Active</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <div class="text-center"><i
                                    [routerLink]="['/companydocument/companypolicymaster/add/',TableData['ESS_CompanyPolicyMasterID']]"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsDelete}">
                            <div class="text-center">
                                <button class="btn btn-sm" name="delete" style="color: red;"
                                    (click)="deleteRow(TableData['ESS_CompanyPolicyMasterID'])"><i
                                        class="bi bi-trash-fill"></i></button>
                            </div>
                        </td>
                        <td style="width: 40px;">
                            <div class="text-center" style="width: 80px;">
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    style="font-size: 0.75rem; padding: 0.25rem 0.5rem;" (click)="LinkInTab(TableData)">
                                    <!-- Show video icon if IsTrainingVideo is true, else show info icon -->
                                    <i *ngIf="TableData['IsTrainingVideo']" class="bi bi-play-circle me-1"></i>
                                    <i *ngIf="!TableData['IsTrainingVideo']" class="bi bi-info-square me-1"></i>
                                    View
                                </button>
                            </div>
                        </td>
                        <td style="width: 100px;">{{TableData['ESS_CompanyPolicyTitle']}}
                            <img *ngIf="TableData['Iconlink'] != null && TableData['Iconlink'] != ''" mat-card-image
                                class="userImage small-icon" [src]="TableData['Iconlink']" />
                        </td>
                        <td>{{TableData['ESS_CompanyPolicyTypeTitle']}}</td>
                        <td style="width: 50px;">{{TableData['WebESSApplicability']}}</td>
                        <td>{{TableData['IsTrainingVideo']?'Yes':'No'}}</td>
                        <!-- <td>{{TableData['Description']}}</td> -->
                        <!-- <td style="width: 40px;"> -->
                        <!-- <a [href]="TableData['DocumentAttachmentLink']" target="_blank">
                                {{ TableData['DocumentAttachment'] }}
                            </a> -->
                        <!-- <div class="text-center" style="width: 80px;">
                                <button type="button" class="btn btn-outline-primary btn-sm"  style="font-size: 0.75rem; padding: 0.25rem 0.5rem;" (click)="LinkInTab(TableData)">
                                    <i class="bi bi-info-square me-1"></i> View
                                </button>
                            </div> -->
                        <!-- </td> -->
                        <td style="width: 10px;">{{TableData['Active']?'Yes':'No'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>